import { FC, SVGAttributes } from 'react';

const Camera: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.582 2.25615C12.4401 2.59768 12.7026 3.7871 13.0535 4.16942C13.4044 4.55173 13.9065 4.68172 14.1843 4.68172C15.6609 4.68172 16.858 5.87879 16.858 7.35452V12.2779C16.858 14.2574 15.2523 15.8631 13.2727 15.8631H4.72588C2.74549 15.8631 1.14062 14.2574 1.14062 12.2779V7.35452C1.14062 5.87879 2.33769 4.68172 3.81427 4.68172C4.09124 4.68172 4.59334 4.55173 4.94507 4.16942C5.29595 3.7871 5.55762 2.59768 6.41571 2.25615C7.27464 1.91462 10.724 1.91462 11.582 2.25615Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.6671 6.88524H13.6747"
                stroke="currentColor"
                strokeWidth="1.69917"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.7025 9.96646C11.7025 8.47459 10.4935 7.26562 9.00162 7.26562C7.50974 7.26562 6.30078 8.47459 6.30078 9.96646C6.30078 11.4583 7.50974 12.6673 9.00162 12.6673C10.4935 12.6673 11.7025 11.4583 11.7025 9.96646Z"
                stroke="currentColor"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Camera;
